<template>
  <div>
    <input
      ref="file"
      class="inputfile"
      type="file"
      multiple
      @change="adicionarFotos"
    />
    <md-button class="md-raised md-primary" @click="() => $refs.file.click()">
      <md-icon>add</md-icon>
      Adicionar fotos
    </md-button>

    <md-divider />
    <div class="row">
      <div v-for="(foto, i) in fotos" :key="i" class="col-6">
        <md-button
          class="md-icon-button md-list-action"
          @click="() => removerFoto(i)"
        >
          <md-icon>clear</md-icon>
        </md-button>
        <img :src="foto.reader.result" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FormularioFotos',
  props: {},
  data() {
    return {
      fotos: [],
    }
  },
  methods: {
    adicionarFotos(event) {
      for (let i = 0; i < event.target.files.length; i++) {
        const reader = new FileReader()

        reader.onload = () => {
          this.fotos.push({
            reader: reader,
            extension: event.target.files[i].name.split('.').pop(),
          })
          this.emitChange()
        }

        reader.readAsDataURL(event.target.files[i])
      }
    },
    removerFoto: function (index) {
      this.fotos.splice(index, 1)
      this.emitChange()
    },
    emitChange() {
      this.$emit(
        'change',
        this.fotos.map((e) => ({
          data: e.reader.result.split(',')[1],
          extension: e.extension,
        }))
      )
    },
  },
}
</script>

<style lang="scss" scoped>
.inputfile {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
  display: none;
}
</style>
